<template>
  <div class="sub-bottom-bar">
    <transition-group
      class="sub-bottom-bar__nav-items"
      @before-enter="beforeEnter"
      @enter="enter"
      @afterEnter="afterEnter"
      @leave="leave"
    >
      <div
        v-for="(navItem, index) in navItems"
        class="sub-bottom-bar__nav-item-wrapper"
        :data-index="index"
        :key="navItem._id"
      >
        <router-link
          class="sub-bottom-bar__nav-item touch"
          :class="{ 'sub-bottom-bar__nav-item--active': $route.fullPath === navItem.to }"
          tag="button"
          :to="`/category/${$store.state.route.params.categoryId}/page/${navItem.pageId}`"
          @click.native="playClickSound()"
        >
          <span v-html="navItem.label[lang.code]"></span>
        </router-link>
      </div>
    </transition-group>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      navItems: [],
    }
  },

  computed: {
    ...mapGetters({
      lang: 'language',
      activeNavItems: 'activeSubNavigation'
    })
  },

  watch: {
    activeNavItems (newItems, oldItems) {
      if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
        this.navItems = []
        this.animationStart()
        setTimeout(() => {
          this.navItems = this.activeNavItems
        }, 300)
      }
    }
  },

  mounted () {
    this.navItems = this.activeNavItems
  },

  methods: {
    ...mapActions([
      'playClickSound'
    ]),

    animationStart () {
        this.$emit('animationStart')
        this.$store.commit('SUB_NAV_ANIMATE_START')
    },

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        setTimeout(() => {
          done()
        }, 300)
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        this.$store.commit('SUB_NAV_ANIMATE_END')
      }
    },

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.sub-bottom-bar {
  background-color: rgba($black, 0.67);
  bottom: 10rem;
  left: 0;
  right: 32.5rem;
  height: 5rem;
  position: absolute;

  &__nav-items-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  &__nav-items {
    align-items: center;
    display: flex;
    height: 5rem;
    justify-content: center;

    svg {
      margin-right: 1em;
    }

    button {
      border: 1px solid #fff;
      color: $white;
      display: block;
      font-size: 1.1rem;
      font-weight: 400;
      height: 2.5rem;
      border-radius: 2.5rem;
      letter-spacing: .15rem;
      line-height: 0;
      margin: 0 .5rem;
      text-align: center;
      width: 17.5rem;

      &.router-link-active {
        color: $black;
      }

      &[disable] {
        pointer-events: none;
      }

      &.active, &.router-link-active {
        border-color: $bottombar-text-color-active;
        color: $bottombar-text-color-active;
      }
    }
  }

  &__nav-item {
    margin: 1.25rem 0 0;
    transition: opacity 0.6s;

    &--disabled {
      opacity: 0.2;
    }
  }
}
</style>
